import * as React from 'react';
import styled from 'styled-components';

import Box from '../box';


type RootProps = {
	zIndex?: number;
}

const Root = styled.div<RootProps>`
	position: fixed;
	top: 0;
	left: -10000px;
	box-sizing: border-box;
	z-index: ${p => p.zIndex || 2000};
	width: 100%;
	height: 100%;
	transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms;
`;

const View = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	width: 100%;
	height: auto;
	background-color: #fff;
	display: flex;
	flex-flow: column nowrap;
	align-items: stretch;
`;

const Header = styled((props: React.ComponentProps<typeof Box>) => 
	<Box
		padding='20px 80px 20px 120px'
		minHeight='100px'
		display='flex'
		flexDirection='column'
		justifyContent='center'
		{...props}
	/>
)`
	flex: 0 0 auto;
	position: relative;
	width: 100%;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
`;

const Content = styled((props: React.ComponentProps<typeof Box>) => <Box padding='20px 80px 20px 120px' {...props} />)`
	flex: 1 1 auto;
	position: relative;
	overflow: auto;
`;

export {
	Root,
	View,
	Header,
	Content,
};
